
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Lambda} from "@/simulation/Lambda";
    import {AwsService} from "@/simulation/AwsService";
    import {ApiGateway} from "@/simulation/ApiGateway";
    import {Sqs} from "@/simulation/Sqs";
    import {ExternalApi} from "@/simulation/ExternalApi";
    import {EventBridge} from "@/simulation/EventBridge";

    @Component
    export default class ServiceSelector extends Vue {
        @Prop() private service!: AwsService;

        isLambda() {
            return this.service instanceof Lambda;
        }
        isApiGateway() {
            return this.service instanceof ApiGateway;
        }
        isSqs() {
            return this.service instanceof Sqs;
        }
        isEventBridge() {
            return this.service instanceof EventBridge;
        }
        isExternalApi() {
            return this.service instanceof ExternalApi;
        }
    }
